import { ModuleWithResourcesAndTasksResponseApi } from "../../../../DTO/ServerResponseType/Module/Module";
import { AllModuleResourceTypes } from "../../../../Enums/ModuleResourceTypeEnum";
import { ModuleResourceRowDTO } from "../../ModuleEditWindow/DTO/ModuleResourceRowDTO";

export class ModuleRowDTO {
  moduleId: string;
  moduleName: string;
  moduleResourcesByType: ModuleResourceRowDTO[][];
  moduleMaxCost: number;
  moduleOrder: number = 0;
  isModuleOpen: boolean;

  constructor(
    moduleData: ModuleWithResourcesAndTasksResponseApi & {
      isModuleOpen?: boolean;
    }
  ) {
    this.moduleId = moduleData.moduleId;
    this.moduleName = moduleData.moduleName;
    this.isModuleOpen =
      moduleData.isModuleOpen === false ? moduleData.isModuleOpen : true;

    this.moduleResourcesByType = new Array(AllModuleResourceTypes.length);
    for (let i = 0; i < this.moduleResourcesByType.length; i++) {
      this.moduleResourcesByType[i] = [];
    }

    this.moduleMaxCost = 0;

    moduleData.moduleResources.forEach((resource) => {
      let resourceRow = new ModuleResourceRowDTO();
      resourceRow.setFromModuleResourceResponse(resource);
      this.moduleResourcesByType[resourceRow.typeId].push(resourceRow);
    });

    // Calculating the cost of the module
    this.moduleResourcesByType.forEach((resourcesDifType) => {
      this.moduleMaxCost =
        this.moduleMaxCost +
        resourcesDifType.reduce(
          (sum: number, resource: ModuleResourceRowDTO) => sum + resource.cost,
          0
        );
    });
  }
}
